import React, { Component } from 'react';
import { Collapse, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Navbar, NavbarBrand, NavbarToggler, NavItem, Form, NavLink, Input, Table } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import '../../../custom.css'
import '../../../style-new.css'
import axios from 'axios';
//import MyModal from './../../CustomModal/CustomModal';
import Moment from 'react-moment';
import moment from 'moment';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import FilePreview from "react-file-preview-latest";
import downloadIcon from '../../../assets/svg/download.svg';
import closeIcon from '../../../assets/svg/x.svg';

export class PractitionerPatient extends Component {

    constructor(props) {
        super(props);

        this.initialState = {
            loading: true,
            patientId: 0,
            patientAccessionId: 0,
            basicInfo: "",
            assignedinstitution: "",
            diseases: "",
            diagnosticHistory: [],
            emergencyContact: [],
            insuranceDetail: [],
            prescription: [],
            treatmentReport: [],
            assignedlaboratory: "",
            assignedmanufacturer: "",
            patientdiseaseId: "",
            Alldiseases: [],
            showdisease: false,

            preview: false,
            url: "",

            patientaccessionmapping: "",

            diagnosticAnalysis: "",
            diagnosticDate: moment(new Date())._d,
            outcome: "",
            diagnosticDocFiles: [],
            diagnosticdocumentFile: "",
            showdiagnosticerror: "",
            showdiagnostic: false,

            prescriptionDescription: "",
            prescribeDate: moment(new Date())._d,
            prescriptiondocumentFile: "",
            prescriptiondocFiles: [],
            showprescriptionerror: "",
            showprescription: false,

            treatmentDescription: "",
            treatmentDetail: "",
            treatmentDate: moment(new Date())._d,
            treatmentdocumentFile: "",
            treatmentdocFiles: [],
            showtreatmenterror: "",
            showtreatment: false,

            redirect: false,
            // authError: false,
            error: '',
            errorType: '',
            errors: {
                patientdiseaseId: '',

                diagnosticAnalysis: '',
                diagnosticDate: '',
                outcome: '',

                prescriptionDescription: '',
                prescribeDate: '',

                treatmentDescription: '',
                treatmentDetail: '',
                treatmentDate: '',
            },
        };
        this.state = this.initialState;

    }

    componentDidMount() {
        const apiroute = window.$APIPath;
        const url = apiroute + '/api/Disease/getalldisease';
        let data = JSON.stringify({
            isDeleted: true,
            searchString: ''
        });
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then(result => {
            if (result.data.flag) {
                let currentdisease = result.data.outdata.filter(ds => ds.diseaseName.toLowerCase() != "healthindex");
                this.setState({
                    Alldiseases: currentdisease
                }, () => {
                    const param = this.props.match.params;

                    if (param.id != undefined) {
                        this.getData(param.id);
                    }
                });
            }
        }).catch(error => {
            this.setState({ loading: false });
            console.log(error);
        });
    }

    //get detail(for update)
    getData(id) {
        const apiroute = window.$APIPath;
        const url = apiroute + '/api/Patient/getPatientsInfobyAccessionId?id=' + id + '';

        axios.get(url, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                console.log(result);
                if (result.data.flag) {
                    var rData = result.data.outdata;
                    this.setState({
                        basicInfo: rData,
                        patientId: rData.patientId,
                        patientAccessionId: id,
                        assignedinstitution: rData.institutePatient,
                        assignedlaboratory: rData.laboratoryPatient,
                        assignedmanufacturer: rData.manufacturerPatient,

                        patientaccessionmapping: rData.patientAccessionMapping,

                        diseases: rData.patientDisease[0],
                        diagnosticHistory: rData.patientDiagnosticHistory,
                        emergencyContact: rData.patientEmergencyContacts,
                        insuranceDetail: rData.patientInsuranceDetails,
                        prescription: rData.patientPrescription,
                        treatmentReport: rData.patientTreatmentReport,
                        loading: false
                    });
                    console.log(this.state);
                }
                else {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
            });
    }

    toggleExpander = (e) => {
        const hiddenElement = e.currentTarget.nextSibling;
        hiddenElement.className.indexOf("collapse show") > -1 ? hiddenElement.classList.remove("show") : hiddenElement.classList.add("show");
    }

    //add disease
    handleCloseDisease = () => {
        this.setState({
            showdisease: false
        });
    }

    handleShowDisease = () => {
        this.setState({
            showdisease: true,
        });
    }

    handleDiseaseInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let errors = this.state.errors;

        switch (name) {
            case 'patientdiseaseId':
                errors.patientdiseaseId = (!value) ? "Please select disease." : '';
                break;
            default:
                //(!value) ? '' :'This standard is required.'
                break;
        }


        this.setState({ errors, [name]: value }, () => {

        })
    }

    AddPatientDisease(e) {
        e.preventDefault();
        this.setState({ loading: true });
        let errors = this.state.errors;

        let uid = 0;
        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        if (userToken != null) {
            uid = (userToken.userId == null ? 0 : userToken.userId);
        }

        if (this.state.patientdiseaseId != null && this.state.patientdiseaseId != "") {
            const apiroute = window.$APIPath;
            let url = apiroute + '/api/PatientDisease/Save';

            let data = JSON.stringify({
                PatientId: parseInt(this.state.patientId),
                DiseaseId: parseInt(this.state.patientdiseaseId),
                PatientDiseaseId: 0,
                createdBy: uid,
                createdByFlag: "P"
            })

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false,
                        showdisease: false,
                        patientdiseaseId: ''
                    }, this.getData(this.state.patientId));
                    toast.success(result.data.message)
                }
                else {
                    errors.patientdiseaseId = result.data.message;
                    this.setState({ loading: false });
                }
            })
                .catch(error => {
                    this.setState({
                        // authError: true, errorType: 'danger', error: error.message, 
                        loading: false, showdisease: false
                    });
                    toast.error(error.message)
                });
        }
        else {
            errors.patientdiseaseId = "Please select disease.";
            this.setState({ loading: false });
        }
    }
    //end add disease

    //add diagnostic
    handleCloseDiagnostic = () => {
        this.setState({
            showdiagnostic: false
        });
    }

    handleShowDiagnostic = () => {
        this.setState({
            showdiagnostic: true,
        });
    }

    handleDiagnosticDateChange(date) {
        let errors = this.state.errors;
        errors.diagnosticDate = (!date) ? "Please enter diagnostic date." : '';
        this.setState({ diagnosticDate: date })
    }

    handleDiagnosticInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let errors = this.state.errors;

        switch (name) {
            case 'diagnosticDate':
                errors.diagnosticDate = (!value) ? "Please enter diagnostic date." : '';
                break;
            case 'diagnosticAnalysis':
                errors.diagnosticAnalysis = (!value) ? "Please enter diagnostic analysis." : '';
                break;
            case 'outcome':
                errors.outcome = (!value) ? "Please enter outcome." : '';
                break;
            default:
                //(!value) ? '' :'This standard is required.'
                break;
        }


        this.setState({ errors, [name]: value }, () => {

        })
    }

    handleDiagnosticFileInputChange(event) {
        const target = event.target;
        const value = target.files;

        this.setState({
            diagnosticdocumentFile: value
        });
    }

    validateDiagnosticForm = (errors) => {
        let valid = true;

        if (this.state.diagnosticAnalysis == undefined || this.state.diagnosticAnalysis == '') {
            errors.diagnosticAnalysis = 'Please enter diagnostic analysis.';
        }
        if (this.state.diagnosticDate == undefined || this.state.diagnosticDate == '') {
            errors.diagnosticDate = 'Please enter diagnostic date.';
        }
        if (this.state.outcome == undefined || this.state.outcome == '') {
            errors.outcome = 'Please enter outcome.';
        }
        Object.values(errors).forEach(
            // if we have an error string set valid to false
            (val) => val.length > 0 && (valid = false)
        );
        return valid;
    }

    AddPatientDiagnostic(e) {
        e.preventDefault();
        this.setState({ loading: true, showdiagnosticerror: "" });

        let uid = 0;
        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        if (userToken != null) {
            uid = (userToken.userId == null ? 0 : userToken.userId);
        }

        if (this.validateDiagnosticForm(this.state.errors)) {
            const apiroute = window.$APIPath;
            let url = apiroute + '/api/PatientDiagnostic/Save';

            let data = JSON.stringify({
                PatientId: parseInt(this.state.patientId),
                PatientAccessionId: parseInt(this.state.patientAccessionId),
                DiagnosticAnalysis: this.state.diagnosticAnalysis,
                DiagnosticDate: this.state.diagnosticDate,
                Outcome: this.state.outcome,
                PatientDiagnosticId: parseInt(0),
                createdBy: uid,
                createdByFlag: "P"
            })

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(result => {
                if (result.data.flag) {
                    if (this.state.diagnosticdocumentFile != "") {
                        let dData = result.data.outdata;
                        this.filesUploadDocDiagnostic(dData.patientDiagnosticId, result.data.message)
                    }
                    else {
                        this.setState({
                            // authError: true,
                            // errorType: 'success',
                            // error: result.data.message,
                            loading: false,
                            showdiagnostic: false,
                            diagnosticAnalysis: "",
                            diagnosticDate: "",
                            outcome: "",
                            diagnosticdocumentFile: "",
                        }, this.getData(this.state.patientId));
                        toast.success(result.data.message)
                    }
                }
                else {
                    this.setState({
                        loading: false,
                        showdiagnosticerror: result.data.message
                    });
                }
            })
                .catch(error => {
                    this.setState({
                        // authError: true, errorType: 'danger', error: error.message, 
                        loading: false,
                    });
                    toast.error(error.message)
                });
        }
        else {
            this.setState({ loading: false });
        }
    }

    filesUploadDocDiagnostic(id, msg) {
        const apiroute = window.$APIPath;
        let url = apiroute + '/api/PatientDiagnosticFile/Save?id=' + id + '';
        //alert(this.state.diagnosticdocumentFile)
        let files = this.state.diagnosticdocumentFile;
        const data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append(`files[${i}]`, files[i])
        }
        axios.post(url, data, {
            // receive two    parameter endpoint url ,form data
        }).then(result => {
            if (result.data.flag) {
                this.setState({
                    // authError: true,
                    // errorType: 'success',
                    // error: msg,
                    loading: false,
                    showdiagnostic: false
                }, this.getData(this.state.patientId));
                toast.success(msg)
            }
            else {
                this.setState({
                    loading: false,
                    showdiagnosticerror: result.data.message
                });
            }
        }).catch(error => {
            this.setState({
                // authError: true, errorType: 'danger', error: error.message, 
                loading: false,
            });
            toast.error(error.message)
        });
    }
    //end add diagnostic

    //add prescription
    handleClosePrescription = () => {
        this.setState({
            showprescription: false
        });
    }

    handlePrescribeDateChange(date) {
        let errors = this.state.errors;
        errors.prescribeDate = (!date) ? "Please enter prescription date." : '';
        this.setState({ prescribeDate: date })
    }

    handleShowPrescription = () => {
        this.setState({
            showprescription: true,
        });
    }

    handlePrescriptionInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let errors = this.state.errors;

        switch (name) {
            case 'prescribeDate':
                errors.prescribeDate = (!value) ? "Please enter prescription date." : '';
                break;
            case 'prescriptionDescription':
                errors.prescriptionDescription = (!value) ? "Please enter prescription description." : '';
                break;
            default:
                //(!value) ? '' :'This standard is required.'
                break;
        }


        this.setState({ errors, [name]: value }, () => {

        })
    }

    handlePrescriptionFileInputChange(event) {
        const target = event.target;
        const value = target.files;

        this.setState({
            prescriptiondocumentFile: value
        });
    }

    validatePrescriptionForm = (errors) => {
        let valid = true;

        if (this.state.prescriptionDescription == undefined || this.state.prescriptionDescription == '') {
            errors.prescriptionDescription = 'Please enter prescription description.';
        }
        if (this.state.prescribeDate == undefined || this.state.prescribeDate == '') {
            errors.prescribeDate = 'Please enter prescription date.';
        }
        Object.values(errors).forEach(
            // if we have an error string set valid to false
            (val) => val.length > 0 && (valid = false)
        );
        return valid;
    }

    AddPatientPrescription(e) {
        e.preventDefault();
        this.setState({ loading: true, showprescriptionerror: "" });

        let uid = 0;
        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        if (userToken != null) {
            uid = (userToken.userId == null ? 0 : userToken.userId);
        }

        if (this.validatePrescriptionForm(this.state.errors)) {
            const apiroute = window.$APIPath;
            let url = apiroute + '/api/PatientPrescription/Save';

            let data = JSON.stringify({
                PatientId: parseInt(this.state.patientId),
                PatientAccessionId: parseInt(this.state.patientAccessionId),
                PrescriptionDescription: this.state.prescriptionDescription,
                PrescribeDate: this.state.prescribeDate,
                PatientPrescriptionId: parseInt(0),
                createdBy: uid,
                createdByFlag: "P"
            })

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(result => {
                if (result.data.flag) {
                    if (this.state.prescriptiondocumentFile != "") {
                        let dData = result.data.outdata;
                        this.filesUploadDocPrescription(dData.patientPrescriptionId, result.data.message)
                    }
                    else {
                        this.setState({
                            // authError: true,
                            // errorType: 'success',
                            // error: result.data.message,
                            loading: false,
                            showprescription: false,
                            prescriptionDescription: "",
                            prescribeDate: "",
                            prescriptiondocumentFile: "",
                        }, this.getData(this.state.patientId));
                        toast.success(result.data.message)
                    }
                }
                else {
                    this.setState({
                        loading: false,
                        showprescriptionerror: result.data.message
                    });
                }
            })
                .catch(error => {
                    this.setState({
                        // authError: true, errorType: 'danger', error: error.message, 
                        loading: false,
                    });
                    toast.error(error.message)
                });
        }
        else {
            this.setState({ loading: false });
        }
    }

    filesUploadDocPrescription(id, msg) {
        const apiroute = window.$APIPath;
        let url = apiroute + '/api/PatientPrescriptionFile/Save?id=' + id + '';
        //alert(this.state.prescriptiondocumentFile)
        let files = this.state.prescriptiondocumentFile;
        const data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append(`files[${i}]`, files[i])
        }
        axios.post(url, data, {
            // receive two    parameter endpoint url ,form data
        }).then(result => {
            if (result.data.flag) {
                this.setState({
                    // authError: true,
                    // errorType: 'success',
                    // error: msg,
                    loading: false,
                    showprescription: false
                }, this.getData(this.state.patientId));
                toast.success(msg)
            }
            else {
                this.setState({
                    loading: false,
                    showprescriptionerror: result.data.message
                });
            }
        }).catch(error => {
            this.setState({
                // authError: true, errorType: 'danger', error: error.message, 
                loading: false,
            });
            toast.error(error.message)
        });
    }
    //end add prescription

    //add treatment
    handleCloseTreatment = () => {
        this.setState({
            showtreatment: false
        });
    }

    handleShowTreatment = () => {
        this.setState({
            showtreatment: true,
        });
    }

    handleTreatmentDateChange(date) {
        let errors = this.state.errors;
        errors.treatmentDate = (!date) ? "Please enter treatment date." : '';
        this.setState({ treatmentDate: date })
    }

    handleTreatmentInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let errors = this.state.errors;

        switch (name) {
            case 'treatmentDate':
                errors.treatmentDate = (!value) ? "Please enter treatment date." : '';
                break;
            case 'treatmentDetail':
                errors.treatmentDetail = (!value) ? "Please enter treatment detail." : '';
                break;
            case 'treatmentDescription':
                errors.treatmentDescription = (!value) ? "Please enter escription." : '';
                break;
            default:
                //(!value) ? '' :'This standard is required.'
                break;
        }


        this.setState({ errors, [name]: value }, () => {

        })
    }

    handleTreatmentFileInputChange(event) {
        const target = event.target;
        const value = target.files;

        this.setState({
            treatmentdocumentFile: value
        });
    }

    validateTreatmentForm = (errors) => {
        let valid = true;

        if (this.state.treatmentDetail == undefined || this.state.treatmentDetail == '') {
            errors.treatmentDetail = 'Please enter treatment analysis.';
        }
        if (this.state.treatmentDate == undefined || this.state.treatmentDate == '') {
            errors.treatmentDate = 'Please enter treatment date.';
        }
        if (this.state.treatmentDescription == undefined || this.state.treatmentDescription == '') {
            errors.treatmentDescription = 'Please enter description.';
        }
        Object.values(errors).forEach(
            // if we have an error string set valid to false
            (val) => val.length > 0 && (valid = false)
        );
        return valid;
    }

    AddPatientTreatment(e) {
        e.preventDefault();
        this.setState({ loading: true, showtreatmenterror: "" });

        let uid = 0;
        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        if (userToken != null) {
            uid = (userToken.userId == null ? 0 : userToken.userId);
        }

        if (this.validateTreatmentForm(this.state.errors)) {
            const apiroute = window.$APIPath;
            let url = apiroute + '/api/PatientTreatment/Save';

            let data = JSON.stringify({
                PatientId: parseInt(this.state.patientId),
                PatientAccessionId: parseInt(this.state.patientAccessionId),
                TreatmentDetail: this.state.treatmentDetail,
                TreatmentDate: this.state.treatmentDate,
                TeatmentDescription: this.state.treatmentDescription,
                PatientTreatmentReportId: parseInt(0),
                createdBy: uid,
                createdByFlag: "P"
            })

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(result => {
                if (result.data.flag) {
                    if (this.state.treatmentdocumentFile != "") {
                        let dData = result.data.outdata;
                        this.filesUploadDocTreatment(dData.patientTreatmentReportId, result.data.message)
                    }
                    else {
                        this.setState({
                            // authError: true,
                            // errorType: 'success',
                            // error: result.data.message,
                            loading: false,
                            showtreatment: false,
                            treatmentDetail: "",
                            treatmentDate: "",
                            treatmentDescription: "",
                            treatmentdocumentFile: "",
                        }, this.getData(this.state.patientId));
                        toast.success(result.data.message)
                    }
                }
                else {
                    this.setState({
                        loading: false,
                        showtreatmenterror: result.data.message
                    });
                }
            })
                .catch(error => {
                    this.setState({
                        // authError: true, errorType: 'danger', error: error.message, 
                        loading: false,
                    });
                    toast.error(error.message)
                });
        }
        else {
            this.setState({ loading: false });
        }
    }

    filesUploadDocTreatment(id, msg) {
        const apiroute = window.$APIPath;
        let url = apiroute + '/api/PatientTreatmentFile/Save?id=' + id + '';
        //alert(this.state.treatmentdocumentFile)
        let files = this.state.treatmentdocumentFile;
        const data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append(`files[${i}]`, files[i])
        }
        axios.post(url, data, {
            // receive two    parameter endpoint url ,form data
        }).then(result => {
            if (result.data.flag) {
                this.setState({
                    // authError: true,
                    // errorType: 'success',
                    // error: msg,
                    loading: false,
                    showtreatment: false
                }, this.getData(this.state.patientId));
                toast.success(msg)
            }
            else {
                this.setState({
                    loading: false,
                    showtreatmenterror: result.data.message
                });
            }
        }).catch(error => {
            this.setState({
                // authError: true, errorType: 'danger', error: error.message, 
                loading: false,
            });
            toast.error(error.message)
        });
    }
    //end add treatment

    //file preview
    previewToggle (e, file) {
        this.setState({
        preview: !this.state.preview,
        url: file
        })
    }

    onError = (err) => console.log("Error:", err); // Write your own logic

    loading() {
        if (this.state.loading) {
            return <div id="loader-wrapper">
                <div id="loader"></div>
                <div className="loader-section section-left"></div>
                <div className="loader-section section-right"></div>
            </div>;
        }
    }

    render() {
        const { loading, patientId, assignedlaboratory, assignedinstitution,
            diseases, diagnosticHistory, emergencyContact, insuranceDetail,
            prescription, treatmentReport, basicInfo, url, preview,
            patientaccessionmapping, patientAccessionId,
            Alldiseases, patientdiseaseId, showdisease,

            diagnosticAnalysis, diagnosticDate, outcome, diagnosticdocumentFile,
            showdiagnosticerror, showdiagnostic,

            prescriptionDescription, prescribeDate, prescriptiondocumentFile,
            prescriptiondocFiles, showprescriptionerror, showprescription,

            treatmentDescription, treatmentDetail, treatmentDate, treatmentdocumentFile,
            treatmentdocFiles, showtreatmenterror, showtreatment, assignedmanufacturer,


            errors, error, errorType, authError } = this.state;

        return (


            <React.Fragment>
                <div className="kt-grid kt-grid--hor kt-grid--root">
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                        <button className="kt-aside-close " id="kt_aside_close_btn"><i className="la la-close"></i></button>
                        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                            <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                                <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                                    <div className="kt-container  kt-container--fluid ">
                                        <div className="kt-subheader__main">
                                            <h3>
                                                <Link to="/practitioner/dashboard" className="kt-subheader__title">
                                                    Dashboard                        
                                                </Link>
                                            </h3>
                                            <span className="kt-subheader__separator kt-hidden"></span>
                                            <div className="kt-subheader__breadcrumbs">
                                                <Link className="kt-subheader__breadcrumbs-home"><i className="flaticon2-arrow"></i></Link>
                                                {/*<span className="kt-subheader__breadcrumbs-separator"></span>*/}
                                                <Link to={`/practitioner/patient/profile/${basicInfo.patientId}`} className="kt-subheader__breadcrumbs-link">
                                                    Patient Detail                        </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget kt-widget--user-profile-3">
                                                <div className="kt-widget__top">
                                                    {/*<div className="kt-widget__media">
                                                        <img src="./assets/media/users/100_1.jpg" alt="image" />
                                                    </div>
                                                    */}
                                                    <div className="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-bolder kt-font-light kt-hidden">JM</div>
                                                    <div className="kt-widget__content">
                                                        <div className="kt-widget__head">
                                                            <div className="kt-widget__user"> <Link className="kt-widget__username">{basicInfo.firstName != null ? (basicInfo.firstName + " " + basicInfo.lastName) : ""}{patientaccessionmapping.accessionNo != null ? " [" + patientaccessionmapping.accessionNo.replace(/-/g, "") + "]" : ""}</Link>
                                                                <span className="kt-badge kt-badge--bolder kt-badge kt-badge--inline kt-badge--unified-success">{basicInfo.sex == "M" ? "Male" : basicInfo.sex == "F" ? "Female" : "-"}</span>
                                                            </div>
                                                        </div>
                                                        <div className="kt-widget__subhead"> <Link><i className="flaticon2-new-email"></i>{basicInfo.email != null ? basicInfo.email : ""}</Link>
                                                            <Link><i className="flaticon2-calendar"></i>
                                                                {
                                                                    basicInfo.dateOfBirth != null && basicInfo.dateOfBirth != "" ?
                                                                        <React.Fragment>
                                                                            {moment(basicInfo.dateOfBirth).format('MM/DD/YYYY')}
                                                                            <span>{"(" + basicInfo.age + ")"}</span>
                                                                        </React.Fragment>
                                                                        : "NA"
                                                                }
                                                            </Link>
                                                            <Link><i className="flaticon2-phone"></i>{basicInfo.mobile != null ? basicInfo.mobile + (basicInfo.phoneNumber != null ? ", " + basicInfo.phoneNumber : "") : "NA"}</Link>
                                                        </div>
                                                        <div className="kt-widget__info">
                                                            <div className="kt-widget__desc">
                                                                <i className="flaticon2-placeholder">{basicInfo.address != null ? basicInfo.address + " - " + basicInfo.postalCode : "NA"}</i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*</div>*/}
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className="kt-portlet">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">
                                                                Basic Details</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-form kt-form--label-right">
                                                        {/* {authError ?
                                                            <div className={"alert alert-" + errorType + " alert-dismissible"} role="alert">
                                                                <div className="alert-text">{error}</div>
                                                                <div className="alert-close">
                                                                    <i className="flaticon2-cross kt-icon-sm" data-dismiss="alert"></i>
                                                                </div>
                                                            </div>
                                                            : null} */}
                                                        <div className="kt-portlet__body">
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">First Name:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.firstName != null ? (basicInfo.firstName) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Middle Name:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.middleName != null ? (basicInfo.middleName) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Last Name:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.lastName != null ? (basicInfo.lastName) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Email:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.email != null ? (basicInfo.email) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Date of Birth:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">
                                                                        {
                                                                            basicInfo.dateOfBirth != null && basicInfo.dateOfBirth != "" ?
                                                                                <React.Fragment>
                                                                                    {moment(basicInfo.dateOfBirth).format('MM/DD/YYYY')}
                                                                                    <span>{"(" + basicInfo.age + ")"}</span>
                                                                                </React.Fragment>
                                                                                : "NA"
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Sex:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.sex == "M" ? "Male" : basicInfo.sex == "F" ? "Female" : "-"}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Primary Phone:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.mobile != null ? (basicInfo.mobile) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Secondary Phone:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.phoneNumber != null ? (basicInfo.phoneNumber) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Height:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.height != null ? (basicInfo.height) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Weight:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.weight != null ? (basicInfo.weight) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Address:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.address != null ? basicInfo.address + " - " + basicInfo.postalCode : "NA"}</span>
                                                                </div>
                                                            </div>

                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">Country:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.country != null ? (basicInfo.country) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">State:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.state != null ? (basicInfo.state) : ""}</span>
                                                                </div>
                                                            </div>
                                                            <div className="form-group form-group-xs row">
                                                                <label className="col-4 col-form-label">City:</label>
                                                                <div className="col-8">
                                                                    <span className="form-control-plaintext kt-font-bolder">{basicInfo.city != null ? (basicInfo.city) : ""}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12">
                                                <div className="kt-portlet">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">
                                                                Institution</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-form kt-form--label-right">
                                                        <div className="kt-portlet__body">

                                                            {assignedinstitution != "" && assignedinstitution != null ?
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Name</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedinstitution.instituteName}</span>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Email</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedinstitution.instituteEmail}</span>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Phone</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedinstitution.institutePhone}</span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <span className="form-control-plaintext kt-font-bolder">Not Assigned</span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12">
                                                <div className="kt-portlet">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">
                                                                Laboratory</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-form kt-form--label-right">
                                                        <div className="kt-portlet__body">
                                                            {assignedlaboratory.length > 0 ? (
                                                                assignedlaboratory
                                                                    .map((data, i) => {
                                                                        return (
                                                                            <div className="form-group form-group-xs row">
                                                                                <div className="col-4">
                                                                                    <label className="col-form-label">Name</label>
                                                                                    <span className="form-control-plaintext kt-font-bolder">{data.ngsLaboratoryName}</span>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <label className="col-form-label">Email</label>
                                                                                    <span className="form-control-plaintext kt-font-bolder">{data.ngsLaboratoryEmail}</span>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <label className="col-form-label">Phone</label>
                                                                                    <span className="form-control-plaintext kt-font-bolder">{data.ngsLaboratoryPhone}</span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }))
                                                                :
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <span className="form-control-plaintext kt-font-bolder">Not Assigned</span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12">
                                                <div className="kt-portlet">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">
                                                                Manufacture</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-form kt-form--label-right">
                                                        <div className="kt-portlet__body">

                                                            {assignedmanufacturer != "" && assignedmanufacturer != null ?
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Name</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedmanufacturer.manufacturerName}</span>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Email</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedmanufacturer.manufacturerEmail}</span>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <label className="col-form-label">Phone</label>
                                                                        <span className="form-control-plaintext kt-font-bolder">{assignedmanufacturer.manufacturerPhone}</span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <span className="form-control-plaintext kt-font-bolder">Not Assigned</span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12">
                                                <div className="kt-portlet">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">
                                                                Disease</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-form kt-form--label-right">
                                                        <div className="kt-portlet__body">
                                                            {diseases != "" && diseases != null ?
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <span className="form-control-plaintext kt-font-bolder">{diseases.diseaseName + " (" + diseases.diseaseCode + ")"}</span>
                                                                    </div>
                                                                    <br />
                                                                    <div className="col-12">
                                                                        <span className="form-control-plaintext kt-font-bolder">Tissue - {diseases.tissue != null ? diseases.tissue : ""}</span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="form-group form-group-xs row">
                                                                    <div className="col-4">
                                                                        <Button className="btn btn-bold btn-label-brand btn-sm" onClick={() => this.handleShowDisease()}>
                                                                            Add Disease
      </Button>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12">
                                                <div className="kt-portlet kt-portlet--tabs">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-toolbar">
                                                            <ul className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand" role="tablist">
                                                                <li className="nav-item">
                                                                    <a className="nav-link active" data-toggle="tab" href="#kt_apps_contacts_view_tab_1" role="tab">Diagnostics</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-toggle="tab" href="#kt_apps_contacts_view_tab_2" role="tab">Prescription</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-toggle="tab" href="#kt_apps_contacts_view_tab_3" role="tab">Treatments/Visit</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-toggle="tab" href="#kt_apps_contacts_view_tab_4" role="tab">Emergency Contacts</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-toggle="tab" href="#kt_apps_contacts_view_tab_5" role="tab">Insurances</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="kt-portlet__body">
                                                        <div className="tab-content">
                                                            <div className="tab-pane active" id="kt_apps_contacts_view_tab_1" role="tabpanel">
                                                                <div className="kt-notes__media">
                                                                    <span className="kt-notes__icon">
                                                                        <Button className="btn btn-bold btn-label-brand btn-sm" style={{ "marginBottom": "5px" }} onClick={() => this.handleShowDiagnostic()}>
                                                                            Add </Button>
                                                                    </span>
                                                                </div>
                                                                <div className="kt-notes kt-scroll kt-scroll--pull" data-scroll="true" style={{ "height": "650px" }}>
                                                                    <div className="kt-notes__items">
                                                                        {diagnosticHistory.length > 0 ? (
                                                                            diagnosticHistory
                                                                                .map((data, i) => {
                                                                                    return (
                                                                                        <div className="kt-notes__item">
                                                                                            <div className="kt-notes__media">
                                                                                                <span className="kt-notes__icon">
                                                                                                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon">
                                                                                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                                                            <polygon points="0 0 24 0 24 24 0 24"></polygon>
                                                                                                            <path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fillRule="nonzero"></path>
                                                                                                            <path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fillRule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "></path>
                                                                                                        </g>
                                                                                                    </svg>
                                                                                                </span>
                                                                                            </div>
                                                                                            <div className="kt-notes__content">
                                                                                                <div className="date-info">
                                                                                                    <span className="kt-notes__desc">
                                                                                                        <Moment format="MM/DD/YYYY">
                                                                                                            {data.diagnosticDate}
                                                                                                        </Moment>
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="kt-notes__section">

                                                                                                    {/*<div className="kt-notes__info"> <p className="kt-notes__title">MRI
																		<br />Lumbo Sacral Spine<br />Findings</p>
                                                                                    </div>*/}
                                                                                                </div> <span className="kt-notes__body">
                                                                                                    {data.diagnosticAnalysis}
                                                                                                </span>
                                                                                                <div className="pt-2 note-dtails-steps"><span className="kt-widget1__number kt-font-danger">Outcome :  {data.outcome}</span></div>
                                                                                                <div className="kt-widget4">
                                                                                                    <br />
                                                                                                    {data.patientDiagnosticHistoryFile.length > 0 ? (
                                                                                                        data.patientDiagnosticHistoryFile
                                                                                                            .map((dataFile, i) => {
                                                                                                                return (
                                                                                                                    <div className="kt-widget4__item" key={dataFile.patientDiagnosticFileId} onClick={e => this.previewToggle(e, dataFile.filePath)}>
                                                                                                                        <div className="kt-widget4__pic kt-widget4__pic--icon">
                                                                                                                            <img src="./assets/media/icons/svg/Files/Download.svg" alt="" />
                                                                                                                        </div>
                                                                                                                        <a className="kt-widget4__title">
                                                                                                                            {dataFile.fileName}
                                                                                                                        </a>
                                                                                                                        {/*<div className="kt-widget4__tools">
                                                                                                                                <a href={dataFile.filePath} className="btn btn-clean btn-icon btn-sm">
                                                                                                                                    <i className="flaticon2-download-symbol-of-down-arrow-in-a-rectangle"></i>
                                                                                                                                </a>
                                                                                                                            </div>*/}
                                                                                                                    </div>
                                                                                                                )
                                                                                                            })) : ("No files...")}
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    )
                                                                                })) : (
                                                                                <span className="kt-notes__body">No diagnostics found.</span>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane" id="kt_apps_contacts_view_tab_2" role="tabpanel">
                                                                <div className="kt-notes kt-scroll kt-scroll--pull" data-scroll="true" style={{ "height": "650px" }}>
                                                                    <div>
                                                                        <Button className="btn btn-bold btn-label-brand btn-sm btn-fr" onClick={() => this.handleShowPrescription()}>
                                                                            Add </Button>
                                                                    </div>
                                                                    <table className="table table-striped- table-bordered table-hover table-checkable" id="kt_table_1">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Prescription Date</th>
                                                                                <th colSpan="2">Description</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {prescription.length > 0 ? (
                                                                                prescription
                                                                                    .map((data, i) => {
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                <tr key={i} onClick={this.toggleExpander}>
                                                                                                    <td><Moment format="MM/DD/YYYY">{data.prescribeDate}</Moment></td>
                                                                                                    <td>{data.prescriptionDescription}</td>
                                                                                                    <td className="tblexpand">
                                                                                                        {/* <img style={{ "width": "80%" }} src="./assets/media/icons/svg/Files/direct-download.svg" alt="" title="View Files" /> */}
                                                                                                        <svg id="color" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                                                                                            <path d="m12 16c-.205 0-.401-.084-.542-.232l-5.25-5.5c-.456-.477-.117-1.268.542-1.268h2.75v-5.75c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25v5.75h2.75c.659 0 .998.791.542 1.268l-5.25 5.5c-.141.148-.337.232-.542.232z" fill="#00bcd4"/>
                                                                                                            <path d="m22.25 22h-20.5c-.965 0-1.75-.785-1.75-1.75v-.5c0-.965.785-1.75 1.75-1.75h20.5c.965 0 1.75.785 1.75 1.75v.5c0 .965-.785 1.75-1.75 1.75z" fill="#607d8b"/>
                                                                                                            <path d="m12 2h-1.25c-.689 0-1.25.561-1.25 1.25v5.75h-2.75c-.659 0-.998.791-.542 1.268l5.25 5.5c.141.148.337.232.542.232z" fill="#00a4b9"/>
                                                                                                            <path d="m12 18h-10.25c-.965 0-1.75.785-1.75 1.75v.5c0 .965.785 1.75 1.75 1.75h10.25z" fill="#546d79"/>
                                                                                                        </svg>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr className="collapse" key={data.patientPrescriptionId}>
                                                                                                    <td className="kt-widget4" colSpan="3">
                                                                                                        {data.patientPrescriptionFile.length > 0 ? (
                                                                                                            data.patientPrescriptionFile
                                                                                                                .map((dataFile, i) => {
                                                                                                                    return (
                                                                                                                        <div className="kt-widget4__item" key={dataFile.patientPrescriptionFileId} onClick={e => this.previewToggle(e, dataFile.filePath)}>
                                                                                                                            <div className="kt-widget4__pic kt-widget4__pic--icon">
                                                                                                                                <img src="./assets/media/icons/svg/Files/Download.svg" alt="" />
                                                                                                                            </div>
                                                                                                                            <a className="kt-widget4__title">
                                                                                                                                {dataFile.fileName}
                                                                                                                            </a>
                                                                                                                            {/*<div className="kt-widget4__tools">
                                                                                                                                <a href={dataFile.filePath} className="btn btn-clean btn-icon btn-sm">
                                                                                                                                    <i className="flaticon2-download-symbol-of-down-arrow-in-a-rectangle"></i>
                                                                                                                                </a>
                                                                                                                            </div>*/}
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                })) : ("No files...")}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    })) : (
                                                                                    <tr>
                                                                                        <td colSpan="2" className="tdCenter">No prescription found.</td></tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane" id="kt_apps_contacts_view_tab_3" role="tabpanel">
                                                                <div className="kt-notes kt-scroll kt-scroll--pull" data-scroll="true" style={{ "height": "650px" }}>
                                                                    <div>
                                                                        <Button className="btn btn-bold btn-label-brand btn-sm btn-fr" onClick={() => this.handleShowTreatment()}>
                                                                            Add </Button>
                                                                    </div>
                                                                    <table className="table table-striped- table-bordered table-hover table-checkable" id="kt_table_1">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Treatment Date</th>
                                                                                <th>Detail</th>
                                                                                <th colSpan="2">Description</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {treatmentReport.length > 0 ? (
                                                                                treatmentReport
                                                                                    .map((data, i) => {
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                <tr key={i} onClick={this.toggleExpander}>
                                                                                                    <td><Moment format="MM/DD/YYYY">{data.treatmentDate}</Moment></td>
                                                                                                    <td>{data.treatmentDetail}</td>
                                                                                                    <td>{data.teatmentDescription}</td>
                                                                                                    <td className="tblexpand">
                                                                                                        {/* <img style={{ "width": "80%" }} src="./assets/media/icons/svg/Files/direct-download.svg" alt="" title="View Files" /> */}
                                                                                                        <svg id="color" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                                                                                            <path d="m12 16c-.205 0-.401-.084-.542-.232l-5.25-5.5c-.456-.477-.117-1.268.542-1.268h2.75v-5.75c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25v5.75h2.75c.659 0 .998.791.542 1.268l-5.25 5.5c-.141.148-.337.232-.542.232z" fill="#00bcd4"/>
                                                                                                            <path d="m22.25 22h-20.5c-.965 0-1.75-.785-1.75-1.75v-.5c0-.965.785-1.75 1.75-1.75h20.5c.965 0 1.75.785 1.75 1.75v.5c0 .965-.785 1.75-1.75 1.75z" fill="#607d8b"/>
                                                                                                            <path d="m12 2h-1.25c-.689 0-1.25.561-1.25 1.25v5.75h-2.75c-.659 0-.998.791-.542 1.268l5.25 5.5c.141.148.337.232.542.232z" fill="#00a4b9"/>
                                                                                                            <path d="m12 18h-10.25c-.965 0-1.75.785-1.75 1.75v.5c0 .965.785 1.75 1.75 1.75h10.25z" fill="#546d79"/>
                                                                                                        </svg>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr className="collapse" key={data.patientTreatmentReportId}>
                                                                                                    <td className="kt-widget4" colSpan="4">
                                                                                                        {data.patientTreatmentReportFile.length > 0 ? (
                                                                                                            data.patientTreatmentReportFile
                                                                                                                .map((dataFile, i) => {
                                                                                                                    return (
                                                                                                                        <div className="kt-widget4__item" key={dataFile.patientTreatmentreportFileId} onClick={e => this.previewToggle(e, dataFile.filePath)}>
                                                                                                                            <div className="kt-widget4__pic kt-widget4__pic--icon">
                                                                                                                                <img src="./assets/media/icons/svg/Files/Download.svg" alt="" />
                                                                                                                            </div>
                                                                                                                            <a className="kt-widget4__title">
                                                                                                                                {dataFile.fileName}
                                                                                                                            </a>
                                                                                                                            {/*<div className="kt-widget4__tools">
                                                                                                                                <a href={dataFile.filePath} className="btn btn-clean btn-icon btn-sm">
                                                                                                                                    <i className="flaticon2-download-symbol-of-down-arrow-in-a-rectangle"></i>
                                                                                                                                </a>
                                                                                                                            </div>*/}
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                })) : ("No files...")}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    })) : (
                                                                                    <tr>
                                                                                        <td colSpan="3" className="tdCenter">No treatment found.</td></tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane" id="kt_apps_contacts_view_tab_4" role="tabpanel">
                                                                <div className="kt-notes kt-scroll kt-scroll--pull" data-scroll="true" style={{ "height": "650px" }}>
                                                                    <table className="table table-striped- table-bordered table-hover table-checkable" id="kt_table_1">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Name</th>
                                                                                <th>Email</th>
                                                                                <th>Phone</th>
                                                                                <th>Address</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {emergencyContact.length > 0 ? (
                                                                                emergencyContact
                                                                                    .map((data, i) => {
                                                                                        return (<tr key={i}>
                                                                                            <td>{data.firstName + " " + data.lastName}</td>
                                                                                            <td>{data.email}</td>
                                                                                            <td>{data.mobile} <br />{data.phoneNumber}</td>
                                                                                            <td>{data.address + " - " + data.postalCode}</td>
                                                                                        </tr>
                                                                                        )
                                                                                    })) : (
                                                                                    <tr>
                                                                                        <td colSpan="4" className="tdCenter">No emergency contacts found.</td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane" id="kt_apps_contacts_view_tab_5" role="tabpanel">
                                                                <div className="kt-notes kt-scroll kt-scroll--pull" data-scroll="true" style={{ "height": "650px" }}>
                                                                    <table className="table table-striped- table-bordered table-hover table-checkable" id="kt_table_1">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Insurance Company</th>
                                                                                <th>Policy Number</th>
                                                                                <th>Health Plan</th>
                                                                                <th>Member ID</th>
                                                                                <th>Group Number</th>
                                                                                <th>Phone</th>
                                                                                <th>Address</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {insuranceDetail.length > 0 ? (
                                                                                insuranceDetail
                                                                                    .map((data, i) => {
                                                                                        return (<tr key={i}>
                                                                                            <td>{data.insuranceCompany}</td>
                                                                                            <td>{data.policyNumber}</td>
                                                                                            <td>{data.healthPlan}</td>
                                                                                            <td>{data.memberID}</td>
                                                                                            <td>{data.groupNumber}</td>
                                                                                            <td>{data.phoneNumber}</td>
                                                                                            <td>{data.address}</td>
                                                                                        </tr>
                                                                                        )
                                                                                    })) : (
                                                                                    <tr>
                                                                                        <td colSpan="7" className="tdCenter">No insurance detail found.</td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <Modal isOpen={showdisease} className="modal-dialog modal-sm">
                        <ModalHeader>
                            Add Disease
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Disease</label>
                                <Input type="select" className="custom-select mb-3" name="patientdiseaseId" value={patientdiseaseId} onChange={this.handleDiseaseInputChange.bind(this)}>
                                    <option value="">Select Disease</option>
                                    {Alldiseases
                                        .map((data, i) => {
                                            return (<option key={i} value={data.diseaseId}>{data.diseaseName}</option>);
                                        })}
                                </Input>
                                {errors.patientdiseaseId.length > 0 && <span className='error'>{errors.patientdiseaseId}</span>}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.handleCloseDisease}>
                                Close
          </Button>
                            {loading ?
                                <Button color="primary" disabled onClick={this.AddPatientDisease.bind(this)}>
                                    Add
          </Button> :
                                <Button color="primary" onClick={this.AddPatientDisease.bind(this)}>
                                    Add
          </Button>}
                        </ModalFooter>
                    </Modal>


                    <Modal isOpen={showdiagnostic} className="modal-dialog modal-lg">
                        <ModalHeader>
                            Add Diagnostic
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Diagnostic Date<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                {/* <Input type="date" name="diagnosticDate" max="9999-12-31" tabIndex="1" min="1000-01-01" className="form-control" value={diagnosticDate} onChange={this.handleDiagnosticInputChange.bind(this)} placeholder="Enter a diagnostic date" /> */}
                                <DatePicker 
                                    selected={diagnosticDate}
                                    onChange={this.handleDiagnosticDateChange.bind(this)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                                {errors.diagnosticDate.length > 0 && <span className='error'>{errors.diagnosticDate}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Diagnostic Analysis<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                <Input type="textarea" name="diagnosticAnalysis" tabIndex="2" className="form-control" value={diagnosticAnalysis} onChange={this.handleDiagnosticInputChange.bind(this)} placeholder="Enter a diagnostic analysis" />
                                {errors.diagnosticAnalysis.length > 0 && <span className='error'>{errors.diagnosticAnalysis}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Outcome<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                <Input type="textarea" name="outcome" tabIndex="3" className="form-control" value={outcome} onChange={this.handleDiagnosticInputChange.bind(this)} placeholder="Enter a outcome" />
                                {errors.outcome.length > 0 && <span className='error'>{errors.outcome}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Diagnostic File</label>
                                <Input type="file" name="diagnosticdocumentFile" id="File" className="form-control" multiple="multiple" tabIndex="4" onChange={this.handleDiagnosticFileInputChange.bind(this)} />
                            </div>
                            {showdiagnosticerror != "" &&
                                <div>
                                    <span className='error'>{showdiagnosticerror}</span>
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.handleCloseDiagnostic}>
                                Close
          </Button>
                            {loading ?
                                <Button color="primary" disabled onClick={this.AddPatientDiagnostic.bind(this)}>
                                    Add
          </Button> : <Button color="primary" onClick={this.AddPatientDiagnostic.bind(this)}>
                                    Add
          </Button>}
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={showprescription} className="modal-dialog modal-lg">
                        <ModalHeader>
                            Add Prescription
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Prescription Date<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                {/* <Input type="date" name="prescribeDate" max="9999-12-31" tabIndex="1" min="1000-01-01" className="form-control" value={prescribeDate} onChange={this.handlePrescriptionInputChange.bind(this)} placeholder="Enter a prescription date" /> */}
                                <DatePicker 
                                    selected={prescribeDate}
                                    onChange={this.handlePrescribeDateChange.bind(this)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                                {errors.prescribeDate.length > 0 && <span className='error'>{errors.prescribeDate}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Prescription Description<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                <Input type="textarea" name="prescriptionDescription" tabIndex="2" className="form-control" value={prescriptionDescription} onChange={this.handlePrescriptionInputChange.bind(this)} placeholder="Enter a prescription description" />
                                {errors.prescriptionDescription.length > 0 && <span className='error'>{errors.prescriptionDescription}</span>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Prescription File</label>
                                <Input type="file" name="prescriptiondocumentFile" id="File" className="form-control" multiple="multiple" tabIndex="3" onChange={this.handlePrescriptionFileInputChange.bind(this)} />
                            </div>
                            {showprescriptionerror != "" &&
                                <div>
                                    <span className='error'>{showprescriptionerror}</span>
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.handleClosePrescription}>
                                Close
          </Button>
                            {loading ?
                                <Button color="primary" disabled onClick={this.AddPatientPrescription.bind(this)}>
                                    Add
          </Button> :
                                <Button color="primary" onClick={this.AddPatientPrescription.bind(this)}>
                                    Add
          </Button>
                            }
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={showtreatment} className="modal-dialog modal-lg">
                        <ModalHeader>
                            Add Treatment
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Treatment Date<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                {/* <Input type="date" name="treatmentDate" max="9999-12-31" tabIndex="1" min="1000-01-01" className="form-control" value={treatmentDate} onChange={this.handleTreatmentInputChange.bind(this)} placeholder="Enter a treatment date" /> */}
                                <DatePicker 
                                    selected={treatmentDate}
                                    onChange={this.handleTreatmentDateChange.bind(this)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                                {errors.treatmentDate.length > 0 && <span className='error'>{errors.treatmentDate}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Treatment Detail<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                <Input type="textarea" maxLength="200" name="treatmentDetail" tabIndex="2" className="form-control" value={treatmentDetail} onChange={this.handleTreatmentInputChange.bind(this)} placeholder="Enter a treatment details" />
                                {errors.treatmentDetail.length > 0 && <span className='error'>{errors.treatmentDetail}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Description<span style={{ "color": "red", "font-size": "16px", "margin-left": "3px" }}>*</span></label>
                                <Input type="textarea" name="treatmentDescription" tabIndex="3" className="form-control" value={treatmentDescription} onChange={this.handleTreatmentInputChange.bind(this)} placeholder="Enter a treatment description" />
                                {errors.treatmentDescription.length > 0 && <span className='error'>{errors.treatmentDescription}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="recipient-name" className="form-control-label">Treatment File</label>
                                <Input type="file" name="treatmentdocumentFile" id="File" className="form-control" multiple="multiple" tabIndex="4" onChange={this.handleTreatmentFileInputChange.bind(this)} />
                            </div>
                            {showtreatmenterror != "" &&
                                <div>
                                    <span className='error'>{showtreatmenterror}</span>
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.handleCloseTreatment}>
                                Close
          </Button>
                            {loading ?
                                <Button color="primary" disabled onClick={this.AddPatientTreatment.bind(this)}>
                                    Add
          </Button> :
                                <Button color="primary" onClick={this.AddPatientTreatment.bind(this)}>
                                    Add
          </Button>}
                        </ModalFooter>
                    </Modal>

                    {this.loading()}
                </div>
                {preview &&
                    <>
                        <div className='preview-popup'>
                            <div className='preview-popup-modal'>
                                <div className='preview-popup-header'>
                                    {url.split(".").splice(-1)[0] === "pdf" ? null : 
                                        <a href={url} download target={`_blank`}>
                                            <img src={downloadIcon} style={{ margin:"0 12px", cursor: "pointer" }} alt='download' />
                                        </a>
                                    }
                                    <img src={closeIcon} style={{ cursor: "pointer" }} alt='close' onClick={e => this.previewToggle(e, "")} />
                                </div>
                                <iframe src={url} title="previewFile" width="100%" height="90%" />
                            </div>
                        </div>
                    </>
                }
            </React.Fragment >
        );
    }
}
